import { Check, LucideProps } from "lucide-react";

const CheckIcon = (props: LucideProps) => <Check {...props} />;

export default CheckIcon;
